import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";
import { getPromotionImages } from "./PromotionList";
import i18next from "i18next";
import { useNavigate, useParams } from "react-router";
import List from "./components/LIST";
import LazyImage from "../../components/Loading/lazyImage";
import { isLoggedIn } from "../../utils/isLoggedIn";
import { useTranslation } from "react-i18next";
import useDeviceType from "../../hook/useDeviceType";
import { getGiftList } from "../../api/getApi";
import { isEmptyObject } from "../../utils/isEmptyObject";
import { receiveGift } from "../../api/postApi";
import { useDispatch, useSelector } from "react-redux";
import { globalTrigger, notice } from "../../redux/action/action";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { HiChevronLeft } from "react-icons/hi";

const PromotionDetail = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.${key}`);

  const isMobile = useDeviceType() === "Mobile";

  const { promoId } = useParams();

  const navigate = useNavigate();

  const promotion = List();

  const dispatch = useDispatch();

  const [promotionListData, setPromotionListData] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const { status_code = 0, good_uid = "" } = promotionListData || {};

  const promotionDetail = useMemo(() => {
    return promotion[promoId];
  }, [promoId, i18next.language]);

  useEffect(() => {
    getGiftList()
      .then((data) => {
        const findPromotion = data?.data?.find(
          (item) => item.good_uid === promotionDetail?.good_uid
        );
        setPromotionListData({
          ...findPromotion,
          buttonNotShow: promotionDetail?.buttonNotShow,
        });
      })
      .catch((err) => {})
      .finally(() => {});
  }, [promotionDetail, trigger]);

  const handleUseGift = (goodUid) => {
    setButtonLoading(true);
    receiveGift({
      good_uid: goodUid,
    })
      .then((data) => {
        dispatch(notice("Success", "success"));
        dispatch({ type: "GET_BALANCE" });
        setTrigger((prev) => !prev);
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
      });
  };
  return (
    <motion.main className="px-common-padding-x py-common-padding-y">
      <CloseDetailPage
        className={`!my-0 !py-0 !h-[45px]`}
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("/promotion")}
          />
        }
        title={<></>}
        customClose={<></>}
      />
      <section className="flex flex-col items-center gap-[15px]">
        <div className="rounded-[5px] w-full overflow-hidden pt-[15px] bg-base-light-white dark:bg-base-light-dark">
          <section className="h-[150px] md:h-[290px] w-full px-[15px] rounded-[5px]">
            <LazyImage
              className="!w-full !h-full object-cover"
              src={
                isMobile
                  ? promotionDetail?.image_mobile
                  : promotionDetail?.image_pc
              }
            />
          </section>
          <section className="w-full rounded-[5] min-h-[145px] p-[16px] relative mb-[15px] flex flex-col items-center gap-[15px] font-medium">
            {promotionDetail?.start_date && ( //如果有start_date就顯示 沒有就不顯示
              <span className="text-main-color">
                {promotionDetail?.start_date} ~
              </span>
            )}
            {promotionDetail?.type !== "recommend" && ( //如果type不是recommend就顯示
              <span className="text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
                {promotionDetail?.title}
              </span>
            )}
            <section className="text-base-light-dark w-full dark:text-base-light-white p-4 md:p-8">
              {promotionDetail?.promotion_content}
            </section>
            {promotionDetail?.buttonText && (
              <button
                type="button"
                onClick={() => {
                  if (!isLoggedIn()) {
                    navigate("signin");
                    return;
                  }
                  navigate(promotionDetail?.navigate);
                }}
                className="p-[15px] font-medium rounded-[5px] min-w-[300px] text-light-white bg-main-color"
              >
                {i18n(promotionDetail?.buttonText)}
              </button>
            )}
            {isLoggedIn() &&
            promotionListData?.good_uid &&
            !promotionListData?.buttonNotShow ? (
              <button
                onClick={() => {
                  if (status_code == 1) {
                    handleUseGift(good_uid);
                  }
                }}
                className={`${
                  status_code == 1 ? "!bg-green-500" : "!bg-gray-300"
                } min-w-[300px] p-[15px] text-light-white font-medium hover:bg-hover-main-bg rounded-[5px]`}
                type="button"
                disabled={buttonLoading || status_code !== 1}
              >
                {status_code == 0
                  ? i18n("Cannot Receive")
                  : status_code == 1
                  ? i18n("Can Receive")
                  : status_code == 2
                  ? i18n("Already Received")
                  : status_code == 99 && i18n("Not Eligible")}
              </button>
            ) : null}
          </section>
        </div>
        <span className="text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold text-center ">
          {i18n("Here's how to claim your bonus")}
        </span>
        <div className="flex flex-col items-center gap-[15px] w-full">
          {promotionDetail?.condition?.map((item) => {
            return (
              <div className="bg-base-light-white dark:bg-base-light-dark rounded-[5px] w-full flex flex-col text-lg gap-[5px] md:gap-[10px] p-[20px]">
                <span className="font-semibold text-gold-text">
                  ＊ {item.label}
                </span>
              </div>
            );
          })}
        </div>
      </section>
    </motion.main>
  );
};

export default PromotionDetail;
